import { 
    FILTER_USER
 } from '../types';

const initialState = {
   name: '',
   email: '',
   partner: '-1',
   status: '-1',
}

export default function(state = initialState, action) {
    switch(action.type){
        case FILTER_USER:
            return {
                name: action.filter.name,
                email: action.filter.email,
                partner: action.filter.partner,
                status: action.filter.status,
            }
        default:
            return state;
    }
}